/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { setDeleteModal, setRow, blockOrg, setEditModal }
) => (
  <>
    <OverlayTrigger
      overlay={<Tooltip id="products-edit-tooltip">Lihat File</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm mr-3"
        target="_blank"
        onClick={() => {
          setEditModal(true);
          setRow(row);
        }}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
          />
        </span>
      </a>
    </OverlayTrigger>
    <></>
    <OverlayTrigger
      overlay={<Tooltip id="products-edit-tooltip">Lihat File</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-info btn-sm mr-3"
        href={`${row.file.storage}/${row.file.path}`}
        target="_blank"
      >
        <span className="svg-icon svg-icon-md svg-icon-info">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Visible.svg")} />
        </span>
      </a>
    </OverlayTrigger>
    <> </>
    <OverlayTrigger
      overlay={<Tooltip id="products-delete-tooltip">Hapus File</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-danger btn-sm"
        onClick={() => {
          setDeleteModal(true);
          setRow(row);
        }}
      >
        <span className="svg-icon svg-icon-md svg-icon-danger">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
        </span>
      </a>
    </OverlayTrigger>
  </>
);
